export class ButtonDefinition {
    id = "";
    caption = "";
    isSuccess = false;
    icon = "";
    style = "";

    constructor(id: string, caption: string, isSuccess: boolean, icon: string, style = "", public severity: "success" | "info" | "warn" | "danger" | "help" | "primary" | "secondary" | "contrast" = null) {
        this.id = id;
        this.caption = caption;
        this.isSuccess = isSuccess;
        this.icon = icon;
        this.style = style;
    }
}
